import React, { ForwardedRef } from 'react';

import { useDispatch } from 'react-redux';
import { ClosedCaptioning } from 'components/icons';
import { pushModal } from 'redux/modules/modal';

import {
  OPTION_TILE_FEATURE_PATHS,
  useEditorState,
} from '../context/VideoEditorStateContext';
import AccessControlOptionTile, {
  AccessControlOptionTileProps,
} from './AccessControlOptionTile';

export type CaptionsTileProps<P = unknown> = Pick<
  AccessControlOptionTileProps<P>,
  'className' | 'onClick' | 'params'
>;

const CaptionsTile = React.forwardRef(
  <P extends {} = unknown>(
    props: CaptionsTileProps<P>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const { className, onClick, params } = props;

    const { features, disabled } = useEditorState();
    const dispatch = useDispatch();

    const handleUpgrade = React.useCallback(() => {
      dispatch(pushModal({ name: 'CaptionsUpsell' }));
    }, [dispatch]);

    if (features.captions === 'hidden') {
      return null;
    }

    return (
      <AccessControlOptionTile
        ref={ref}
        id="templates-captions-tile"
        label="captions"
        className={className}
        disabled={disabled}
        featurePath={OPTION_TILE_FEATURE_PATHS.captions}
        icon={<ClosedCaptioning width="48px" height="36px" />}
        params={params}
        onClick={onClick}
        onUpgrade={handleUpgrade}
        proTooltipId="captions-tile-tooltip"
      />
    );
  },
);

export default CaptionsTile;
